import React from "react";
import Button from "../../../UI/Button";
import CountInput from "../../../UI/CountInput";
import { useDispatch, useSelector } from "react-redux";
import useFormatTime from "../../../Global/Api/Shared/useFormatTime";
import { addLineItems, setQuantity } from "../../../Store/Slice/scheduleSlice";
import {useParams} from "react-router-dom";

export default function Total() {
  const {title: jobTitle} = useParams();
  const isRescheduleMode = Boolean(jobTitle);
  const dispatch = useDispatch();
  const { line_items: lineItems, total_price: totalPrice, total_time: totalTime, total_vehicles: totalVehicles } = useSelector((state) => state.rootReducer.scheduleSlice);
  const accountData = useSelector((state) => state.rootReducer.techsbookSlice.userData);
  const {activeJob} = useSelector((state) => state.rootReducer.jobsSlice);
  const { formatTime } = useFormatTime();

  const addItem = () => {
    if (lineItems.length > 0) {
      dispatch(addLineItems());
      dispatch(
          setQuantity({
            id: lineItems[lineItems.length - 1]?.id + 1,
            quantity: 0,
          })
      );
    }
  };


  const showPrice = () => {
    if (+totalPrice % 1 === 0) {
      return totalPrice.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    } else {
      return typeof totalPrice === 'number' ? totalPrice?.toFixed(2) : parseFloat(totalPrice)?.toFixed(2);
    }
  }

  return (
    <div className="lineitems__total">
      <div className="lineitems__row">
        <div className="lineitems__btn">
          {!isRescheduleMode && (
              <Button
                  onClick={addItem}
                  type="blue_transparent"
                  text="Add additional item"
              />
          )}
        </div>
        <div></div>
        <div></div>
        <div className="lineitems__total-price">{accountData?.country_currency_sign} {showPrice()}</div>
        <div className="lineitems__total-price">
          {formatTime(isRescheduleMode ? activeJob?.time : totalTime)} hrs
        </div>
      </div>
    </div>
  );
}
